import { render, staticRenderFns } from "./worthington.vue?vue&type=template&id=5d2dca7b&scoped=true&"
import script from "./worthington.vue?vue&type=script&lang=js&"
export * from "./worthington.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2dca7b",
  null
  
)

export default component.exports